module.exports = __webpack_public_path__ + "img/user.78cd0444.svg";